import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinessOffice = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#f0d26e",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 1,
			width: 10,
			height: 14,
			rx: 1,
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.25,
			y: 3.18005,
			width: 2,
			height: 2,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.75,
			y: 3.18005,
			width: 2,
			height: 2,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5.25,
			y: 6.67212,
			width: 2,
			height: 2,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.75,
			y: 6.67212,
			width: 2,
			height: 2,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.50098,
			y: 10.76,
			width: 2.99805,
			height: 4.23999,
			rx: .5,
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBusinessOffice;
